export const getClasses = ({ text, size = 'large', color = 'primary', variant, isRounded }) => {
  const isNumber = !isNaN(Number(text)) && text !== '';

  const baseClasses = [
    'w-max flex items-center justify-center border border-solid select-none border-black !border-opacity-[12%] whitespace-nowrap',
    isRounded ? 'rounded-full' : 'rounded-md' // rounded 6px
  ];

  const sizeClasses = {
    small: isNumber ? 'min-w-5 h-5 px-1 leading-[14px]' : 'h-5 px-1.5 leading-[14px] gap-0.5', // 20px
    medium: isNumber ? 'min-w-6 h-6 px-1 leading-[14px]' : 'h-6 px-2 leading-[14px] gap-1', // 24px
    large: isNumber ? 'min-w-7 h-7 px-2 leading-4' : 'h-7 px-2 leading-4 gap-1.5' // 28px
  };

  const colorVariants = {
    primary: { filled: 'bg-primary-500', light: 'bg-primary-200', lighter: 'bg-primary-50' },
    violet: { filled: 'bg-violet-500', light: 'bg-violet-200', lighter: 'bg-violet-50' },
    success: { filled: 'bg-success-500', light: 'bg-success-200', lighter: 'bg-success-50' },
    warning: { filled: 'bg-warning-500', light: 'bg-warning-200', lighter: 'bg-warning-50' },
    danger: { filled: 'bg-danger-500', light: 'bg-danger-200', lighter: 'bg-danger-50' },
    neutral: { filled: 'bg-neutral-500', light: 'bg-neutral-200', lighter: 'bg-neutral-50' },
    moss: { filled: 'bg-moss-500', light: 'bg-moss-200', lighter: 'bg-moss-50' },
    'green-light': {
      filled: 'bg-green-light-500',
      light: 'bg-green-light-200',
      lighter: 'bg-green-light-50'
    },
    teal: { filled: 'bg-teal-500', light: 'bg-teal-200', lighter: 'bg-teal-50' }
  };

  const selectedColor = colorVariants[color] || colorVariants.neutral;
  const colorClass = selectedColor[variant] || selectedColor.lighter;

  return [...baseClasses, sizeClasses[size], colorClass].join(' ');
};

export const getTextClasses = (size, variant) => {
  const baseClasses = [
    'font-500 capitalize',
    variant === 'filled' ? 'text-white' : 'text-neutral-700'
  ];

  const lineHeightClasses = {
    small: 'leading-[14px]',
    medium: 'leading-[14px]',
    large: 'leading-[16px]'
  };

  const sizeClasses = {
    small: 'text-[12px]',
    medium: 'text-[12px]',
    large: 'text-[14px]'
  };

  return [...baseClasses, sizeClasses[size], lineHeightClasses[size]].join(' ');
};

export const getIconSize = (size) => (size === 'large' ? 18 : size === 'medium' ? 16 : 14);
